<modal-open-point id="confirmar-checkout-modal-1">
  <div normal>
    <confirmar-checkout-modal></confirmar-checkout-modal>
  </div>
</modal-open-point>

<div *ngIf="modo==='normal'" class="main-checkout-wrapper">
  <div class="container">

    <!-- LADO IZQUIERDO -->
    <div class="productos">
      <div class="productoslabel">Productos ({{articulosconcantidad.length}})</div>
      <div class="listaprod">
        <lista-productos-view [articulosIn]="articulosconcantidad" [modelo]="'postcheckout'">
        </lista-productos-view>
      </div>
    </div>

    <!-- LADO DERECHO -->
    <div class="checkoutcontainer">

      <!-- 1. PERSONAL -->
      <div class="informacionPersonal">
        <div class="productoslabel">Información Personal</div>
        <div class="infobox" *ngIf="user">
          <div class="info infoblue"><strong>{{user.nombre}}</strong></div>
          <div class="info" *ngIf="user.email">{{user.email}}</div>
          <div class="info" *ngIf="user.telefonos">{{user.telefonos}}</div>
        </div>
      </div>

      <!-- 2. RADIOS (SELECCION) -->
      <div class="envioOretiro">
        <div class="productoslabel">¿Envío o Retiro?</div>

        <div class="infoboxElegirEnvio">
          <div class="option-wrapper" *ngIf="envioHabilitado === 'S'">
            <input type="radio" id="optEnvio" name="tipoEntrega" class="custom-radio" [checked]="esEnvio"
              (change)="seleccionoEnvio()">
            <label for="optEnvio" class="option-label">Envío a Domicilio</label>
          </div>

          <div class="option-wrapper" *ngIf="envioExpress && !maxExpress">
            <input type="radio" id="optExpress" name="tipoEntrega" class="custom-radio" [checked]="esExpress"
              (change)="seleccionoEnvioExpress()">
            <label for="optExpress" class="option-label">Envío Express</label>
          </div>

          <div class="option-wrapper">
            <input type="radio" id="optRetiro" name="tipoEntrega" class="custom-radio" [checked]="esRetiro"
              (change)="seleccionoRetiro()">
            <label for="optRetiro" class="option-label">Retiro en Sucursal</label>
          </div>
        </div>
      </div>

      <!-- 3. BLOQUE ENVIO -->
      <div class="envioContainer" *ngIf="esEnvio || esExpress">


        <div *ngIf="observacionEnvio" class="highlight-text">
          <span [innerHTML]="observacionEnvio"></span>
        </div>

        <div class="envio-form-container">
          <app-envios-form (envioSeleccionado)="seEligioDatosEnvio($event)"></app-envios-form>
        </div>
        <!-- ... logica turnos ... -->
        <ng-container *ngIf="usaTurnos == 'S'; else noUsaTurnosRef">
          <div class="productoslabel separator">Elegí fecha y hora</div>
          <mmax-turnos-reparto (turnoSelecionado)="turnoselect($event)"></mmax-turnos-reparto>
        </ng-container>

        <div class="productoslabel separator">Quién recibe</div>
        <div class="infobox" *ngIf="user">
          <div class="info infoblue">{{user.nombre}}</div>
        </div>
      </div>

      <!-- 4. BLOQUE RETIRO -->
      <div class="retiroContainer" *ngIf="esRetiro">
        <div class="productoslabel separator">Sucursal de Retiro</div>
        <div class="infobox" *ngIf="sucursal && sucTrue; else NotSuc">
          <div class="info infoblue"><strong>{{sucursal.nombre}}</strong></div>
          <div class="info">{{sucursal.calle}} - {{sucursal.barrio}}, {{sucursal.localidad}}</div>
        </div>

        <ng-container *ngIf="usaTurnos == 'S'; else noUsaTurnosRef">
          <div class="productoslabel separator">Elegí turno de retiro</div>
          <mmax-turnos-retiro (turnoSelecionado)="turnoselect($event)"></mmax-turnos-retiro>
        </ng-container>

        <div class="productoslabel separator">Quién retira</div>
        <div class="infobox" *ngIf="user">
          <div class="info infoblue">{{user.nombre}}</div>
        </div>
      </div>

      <!-- ... (Observaciones, Totales) ... -->
      <div *ngIf="esEnvio || esExpress || esRetiro">

        <div class="productoslabel separator">Observaciones</div>
        <textarea id="obs" (change)="observaCion()" class="boxobs"
          placeholder="Escribe aquí las aclaraciones..."></textarea>

        <div *ngIf='!ocultarPrecios'>
          <div *ngIf="(esEnvio || esExpress) && envio?.costo" class="subTotal">
            Subtotal: {{totales - envio.costo | currency}} <br>
            Costo de Envío: {{envio.costo | currency}}
          </div>
          <div class="total">Total a Pagar: {{totales | currency}}</div>
        </div>

        <div *ngIf="terminosyCondiciones">
          <a [href]="terminosyCondiciones" class="terminosCondiciones" target="_blank">Leer Términos y Condiciones</a>
        </div>

        <div class="botncontainer">
          <button (click)="iraLand()" class="noselect btons conticompra">Volver / Modificar</button>
          <button (click)="modalCheckout()" class="noselect btons blubutton"
            [disabled]="(usaTurnos == 'S' && !turnoselecionado) || (esRetiro && !sucTrue)">Confirmar Pedido</button>
        </div>
      </div>

    </div>
  </div>
  <mmax-helpfootbar></mmax-helpfootbar>
</div>
<!-- Templates al final -->
<ng-template #noUsaTurnosRef>
  <div class="productoslabel separator">Tiempo de Preparación</div>
  <div class="infobox">
    <div class="info infoblue">
      <i class="fas fa-clock"></i> El pedido puede demorar hasta {{horasMinimasTurno || '24'}} horas.
    </div>
  </div>
</ng-template>

<ng-template #NotSuc>
  <div class="infobox error-box">
    <div class="info" style="color: red;">No tienes una sucursal seleccionada.</div>
    <button class="btons conticompra" style="margin-top: 10px;" (click)="irASuc()">Seleccionar Sucursal</button>
  </div>
</ng-template>